module.exports = __webpack_public_path__ + "img/agala_no.c83a5857.png";